import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { useStyles } from '../login.styles';
import { useUserStore, useEnvStore } from '../../../store/models';
import ForgotEmail from './ForgotEmail';
import RecoverCode from './RecoverCode';

/*
 * Main LoginForgot Component
 */
function LoginForgot (props) {
  const {
    onBackToLogin,
  } = props;

  const Steps = {
    SEND_CODE: 'sendCode',
    VERIFY_CODE: 'verifyCode',
  };

  const userStore = useUserStore();
  const envStore = useEnvStore();

  const classes = useStyles();

  const [step, setStep] = useState(Steps.SEND_CODE);

  function renderStep () {
    if (step === Steps.VERIFY_CODE) {
        return (
          <RecoverCode
            onBackToLogin={onBackToLogin}
            onSendCode={({ code, password }) => {
              return userStore.recoverPassword({ code, password });
            }}

            onResendCode={() => {
              const storeInfo = envStore.getStoredInfo();
              const email = storeInfo?.recovery?.email;
              if (email) {
                return userStore.forgotPassword({ email });
              }
            }}
          />
        );
      }
    return (
      <ForgotEmail
          onSendRecovery={async (email) => {
            try {
              await userStore.forgotPassword({ email: email });
              setStep(Steps.VERIFY_CODE);
            } catch {
              // error is handled by the store via errorStore — do not advance step
            }
          }}
          onBackToLogin={onBackToLogin}
      />
    );
  }

  return (
      <div className={classes.customFormContainer}>
        {renderStep()}
      </div>
  );
}

LoginForgot.propTypes = {
  onBackToLogin: PropTypes.func,
};

LoginForgot.defaultProps = {
  onBackToLogin: () => {},
};

export default observer(LoginForgot);
